<!DOCTYPE html>
<html lang="en">

<head>
  <!-- Required meta tags -->
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
  <title>login</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

</head>

<body>
  <div class="container-scroller">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth px-0">
        <div class="row w-100 mx-0">
          <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left py-5 px-4 px-sm-5">
              <div class="brand-logo" style="text-align: center;">
                <img src="assets/images.png" alt="logo">
              </div>
              <h4>Hello! let's get started</h4>
              <h6 class="font-weight-light">Sign in to continue.</h6>
              <form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
                <div class="form-group">
                  <input type="text" class="form-control" name="username" [(ngModel)]="form.username" required #username="ngModel"
                  placeholder="Username" />
                  <div class="alert alert-danger" role="alert" *ngIf="username.errors && f.submitted">
                    Username is required!
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group">
                    <input [type]="passwordHidden ? 'password' : 'text'" class="form-control" name="password" [(ngModel)]="form.password" required minlength="1" #password="ngModel" placeholder="Password" />
                    <div class="input-group-append">
                      <span class="input-group-text" (click)="togglePasswordVisibility()">
                        <i class="fas" [ngClass]="{'fa-eye-slash': passwordHidden, 'fa-eye': !passwordHidden}"></i>
                      </span>
                    </div>
                  </div>
                  <div class="alert alert-danger" role="alert" *ngIf="password.errors && f.submitted">
                    <div *ngIf="password.errors.required">Password is required</div>
                    <div *ngIf="password.errors.minlength">Password must be at least 4 characters</div>
                  </div>
                </div>
                
                
                <div class="mt-3">
                  <button class="btn btn-primary btn-block">Login</button>

                </div>
                <br>
           
              
                <div class="my-2 d-flex justify-content-between align-items-center">
                  <div class="form-check">
                    <label class="form-check-label text-muted">
                      <input type="checkbox" class="form-check-input">
                      Keep me signed in
                    </label>
                  </div>
                  <a href="#" class="auth-link text-black" routerLink="/forgetpwd">Forgot password?</a>
                </div>
                
                <div class="text-center mt-4 font-weight-light">
                  Don't have an account? <a routerLink="/register"class="text-primary">Create</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>
  <!-- container-scroller -->
  <!-- plugins:js -->
 
  <!-- endinject -->
</body>

</html>
